module.exports = __webpack_public_path__ + "404-54fb909e1b6f1076ab3c8fb5de0e1eaa.svg";